"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.boxPropertiesSchema = exports.stripPropertiesSchema = void 0;
const core_1 = require("../../core");
const SlideShowProperties_schema_1 = require("../../core/slideShow/SlideShowProperties.schema");
exports.stripPropertiesSchema = core_1.createPropertiesSchema('StripContainerSlideShowProperties', SlideShowProperties_schema_1.slideShowProperties);
exports.boxPropertiesSchema = core_1.createPropertiesSchema('BoxSlideShowProperties', SlideShowProperties_schema_1.slideShowProperties);
//# sourceMappingURL=SlideShowContainer.schema.js.map